<template>
    <div class="featuredCourses">
        <div class="featuredCourses-banner">
            <div class="featuredCourses-banner-img-cover">
            </div>
            <div class="featuredCourses-banner-title">
                Learn Mandarin Chinese Easily
            </div>
            <div class="featuredCourses-banner-suggestion-and-question">
                The ultimate structured, comprehensive, easy courses
            </div>
            <div class="featuredCourses-banner-description">
                We provide specific courses to everyone in different fields and needs.
                <br><br>
                You can choose your course according to your current level and goals.
                <br><br>
                Contact us for help to find the most suitable course for you to purchase and study.
            </div>
        </div>
        <div class="featuredCourses-content-categories">
            <div class="featuredCourses-content-categories-logo">
                <img class="featuredCourses-content-categories-logo-pc" src="../assets/img/ata-line.png">
                <img class="featuredCourses-content-categories-logo-mobile" src="../assets/img/mobile/ata-line.png">
            </div>
            <div class="featuredCourses-content-title">
                Courses
            </div>
            <div class="featuredCourses-content-description">
                We provide specific courses to everyone in different field and needs.
            </div>
            <div class="featuredCourses-content-list">
                <div class="featuredCourses-content-nav" :class="{'selected': category.id == courseForm.category_id}" v-for="category in categoryList" :key="category.key"  @click="getCourseList(category.id)">
                  {{ category.name }}
                </div>
                <div class="featuredCourses-content-nav">
                    Coming Soon
                </div>
            </div>
        </div>
        <div class="featuredCourses-content-background">
            <div class="featuredCourses-content">
                <div class="featuredCourses-content-logo">
                    <img class="featuredCourses-content-logo-pc" src="../assets/img/ata-line.png">
                    <img class="featuredCourses-content-logo-mobile" src="../assets/img/mobile/ata-line.png">
                </div>
                <div class="featuredCourses-content-title">
                    Featured Courses
                </div>
                <div class="featuredCourses-content-courses">
                    <div
                        class="featuredCourses-content-courses-card"
                        v-for="course in courseList" :key="course.key"
                        @click="tutorial(course.id)">
                        <div class="featuredCourses-card-thumbnail">
                            <img :src="course.img">
                        </div>
                        <div class="featuredCourses-card-content">
                            <div class="featuredCourses-title">
                                {{course.name}}
                            </div>
                            <div class="featuredCourses-description">
                                {{course.description}}
                            </div>
                            <div class="featuredCourses-coursesinfo">
                                <div class="featuredCourses-coursesauthor">
                                    {{course.author}}
                                </div>
                                <div class="featuredCourses-price">
                                    $ {{course.price}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <FooterBanner />
        -->
    </div>
</template>
<script>
    //import FooterBanner from './FooterBanner.vue';
    export default {
        name: "FeaturedCourse",
        components: {
            //FooterBanner,
        },
        data() {
            return {
                items: 3,
                categoryList:[],
                courseForm: {
                    category_id: 0,
                    page: 1,
                    page_size: 50,
                },
                courseList :[],
            }
        },
        mounted () {
            this.init();
        },
        methods: {
            init() {
                this.getSuggestionList();
            },
            getSuggestionList() {
                this.$api.request('Course/getCategoryList').then((result) => {
                    if (result.status == true) {
                        this.categoryList = result.data;
                        if (this.categoryList.length > 0) {
                            this.courseForm.category_id = this.categoryList[0].id;
                            this.getCourseList(this.categoryList[0].id);
                        }
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
            getCourseList(id) {
                this.courseForm.category_id = id;
                this.$api.request('Course/list', this.courseForm).then((result) => {
                    if (result.status == true) {
                        this.courseList = result.data.list;
                    } else {
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.$message.error(error.msg);
                });
            },
            tutorial(id) {
                this.$router.push({
                    path: "/tutorial"
                })
                console.log(id);
                // if(this.userToken){
                //     console.log(id);

                // } else {
                // }
            }
        }
    }
</script>
<style lang="scss">
    @import "../styles/pc/featuredCourses.scss";
    @import "../styles/mobile/featuredCourses.scss";
</style>
